import { MenuTypes } from '@ori-events/toggle-menu-flyout';
import { getCurrentUrl } from '@ori/presentation-utils';
import { useEffect } from 'react';

import { CONSULTANT_NUMBER_QUERY_PARAM_KEY, RETURN_URL_QUERY_PARAM_KEY } from '../constants';
import { useAppConfig } from '../context';
import { dispatchToggleMenu } from '../utils';

export const useReturnUrl = () => {
  const { externalLoginName } = useAppConfig();
  useEffect(() => {
    const { searchParams } = getCurrentUrl();
    const returnUrl = searchParams.get(RETURN_URL_QUERY_PARAM_KEY);
    const consultantNumberQueryParam = searchParams.get(CONSULTANT_NUMBER_QUERY_PARAM_KEY);
    if (Boolean(returnUrl) || Boolean(externalLoginName) || consultantNumberQueryParam) {
      dispatchToggleMenu(MenuTypes.AccountSideMenu);
    }
  }, [externalLoginName]);
};
